export default {
  EXT_ICONS: [
    'bmp',
    'ai',
    'bat',
    'bpm',
    'default',
    'dll',
    'doc',
    'docm',
    'docx',
    'dot',
    'dotm',
    'dotx',
    'ep',
    'gif',
    'gz',
    'htm',
    'html',
    'ico',
    'jpeg',
    'jpg',
    'log',
    'mht',
    'mhtml',
    'mm',
    'mny',
    'odt',
    'pdf',
    'png',
    'pot',
    'potx',
    'pps',
    'ppsx',
    'ppt',
    'pptx',
    'psd',
    'rar',
    'rtf',
    'sl',
    'tif',
    'tiff',
    'txt',
    'vsd',
    'vsdx',
    'wps',
    'xls',
    'xlsb',
    'xlsm',
    'xlsx',
    'xlt',
    'xltx',
    'xml',
    'xps',
    'zip',
  ],
};
